import { render, staticRenderFns } from "./UserGroupFilterWrapper.vue?vue&type=template&id=4f7d2929&scoped=true&"
import script from "./UserGroupFilterWrapper.vue?vue&type=script&lang=ts&"
export * from "./UserGroupFilterWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupFilterWrapper.vue?vue&type=style&index=0&id=4f7d2929&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d2929",
  null
  
)

export default component.exports